import React from 'react';
import { Translate, TranslateHTML, useTranslate } from 'core/translate';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalFooterButtons,
  ModalFooterCancelButton,
  ModalFooterPrimaryButton,
  ModalHeader
} from '../../common/modal/Modal';
import PriceWithDisclaimer from './PriceWithDisclaimer';
import Raw from '../../common/Raw';
import ModalImage from '../../common/modal/ModalImage';

const EngineTransmissionDetailModal = props => {
  const translate = useTranslate();
  const { option, onClose, disclaimer, selections, onSelect } = props;
  const {
    trimName,
    engine,
    engineDescription,
    engineLongCFD,
    engineLargeImageUrl,
    engineDisclaimer,
    transmission,
    transmissionDescription,
    transmissionLongCFD,
    transmissionLargeImageUrl,
    transmissionDisclaimer,
    msrp,
    message
  } = option;
  const isSelected =
    trimName === selections.trimName &&
    engine === selections.engine &&
    transmission === selections.transmission;

  const header = translate('trim.modal.title', { trim: trimName });
  const showTransmission = engineDescription !== transmissionDescription;

  return (
    <Modal isOpen={true} onRequestClose={onClose}>
      <ModalHeader analyticsKey={header} onClose={onClose} />
      <ModalBody>
        <div>
          <div className="modal-body__header">
            <div>{header}</div>
            {showTransmission ? (
              <TranslateHTML
                as="div"
                value="components.engine.transmission.modal.header"
                engine={engineDescription}
                transmission={transmissionDescription}
              />
            ) : (
              <Raw as="div" value={engineDescription} />
            )}
          </div>
          <div style={{ marginBottom: 10 }}>
            <PriceWithDisclaimer
              value={msrp}
              message={message}
              disclaimer={disclaimer}
              analyticsKey={translate('component.common.select.engine')}
              analyticsKey2={engineDescription}
            />
          </div>
          <div className="modal-body__content">
            <ModalImage alt={engineDescription} url={engineLargeImageUrl} />
            <div className="modal-body__description-container">
              <Raw as="div" value={engineDescription} />
              <Raw as="div" value={engineLongCFD} />
              <Raw
                as="div"
                value={engineDisclaimer}
                className="modal__disclaimer"
              />
            </div>
          </div>
          {showTransmission && (
            <div className="modal-body__content" style={{ marginTop: 10 }}>
              <ModalImage
                alt={transmissionDescription}
                url={transmissionLargeImageUrl}
              />
              <div className="modal-body__description-container">
                <Raw as="div" value={transmissionDescription} />
                <Raw as="div" value={transmissionLongCFD} />
                <Raw
                  as="div"
                  value={transmissionDisclaimer}
                  className="modal__disclaimer"
                />
              </div>
            </div>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <ModalFooterButtons>
          {isSelected ? (
            <ModalFooterPrimaryButton onClick={onClose} />
          ) : (
            <React.Fragment>
              <ModalFooterCancelButton onClick={onClose} />
              <ModalFooterPrimaryButton onClick={onSelect}>
                <Translate value="byo.page.general.select" />
              </ModalFooterPrimaryButton>
            </React.Fragment>
          )}
        </ModalFooterButtons>
      </ModalFooter>
    </Modal>
  );
};

export default EngineTransmissionDetailModal;
